var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 24 24",
    height: 128,
    viewBox: "0 0 24 24",
    width: 129,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m20.5 9.7h-3.2c-.3 0-.5-.2-.5-.5v-2.4h-9.8v2.4c0 .3-.2.5-.5.5h-3.2c-1.2 0-2.3-1.1-2.3-2.3v-2.1c0-1.3 1.1-2.3 2.3-2.3h17.2c1.3 0 2.3 1 2.3 2.3v2.1c0 1.2-1 2.3-2.3 2.3zm-2.7-.9h2.7c.8 0 1.4-.6 1.4-1.4v-2.1c0-.8-.6-1.4-1.4-1.4h-17.2c-.8 0-1.4.6-1.4 1.4v2.1c0 .8.6 1.4 1.4 1.4h2.8v-2.5c0-.2.2-.4.5-.4h10.8c.3 0 .5.2.5.4v2.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m17.3 21h-10.8c-.3 0-.5-.2-.5-.5v-14.2c0-.2.2-.4.5-.4h10.8c.3 0 .5.2.5.4v14.2c0 .3-.2.5-.5.5zm-10.3-.9h9.9v-13.3h-9.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m15.5 6.8h-10.8c-.3 0-.5-.2-.5-.5 0-.2.2-.4.5-.4h10.8c.2 0 .4.2.4.4.1.3-.1.5-.4.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m19.1 6.8h-10.8c-.3 0-.5-.2-.5-.5 0-.2.2-.4.5-.4h10.8c.3 0 .5.2.5.4 0 .3-.2.5-.5.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m11.9 13.4c-1.1 0-1.9-.9-1.9-1.9v-.5c0-1.1.9-2 1.9-2 1.1 0 1.9.9 1.9 1.9 0 .2-.2.4-.5.4s-.5-.2-.5-.4c0-.6-.5-1-1-1-.6 0-1 .4-1 1v.5c0 .6.5 1 1 1 .3 0 .5.2.5.5.1.3-.1.5-.4.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m11.9 16.9c-1.1 0-1.9-.8-1.9-1.9 0-.3.2-.5.4-.5s.4.2.4.5c0 .6.5 1 1 1 .6 0 1-.5 1-1v-.6c0-.6-.5-1-1-1-.2 0-.4-.2-.4-.5s.2-.5.4-.5c1.1 0 1.9.9 1.9 1.9v.7c.2 1.1-.7 1.9-1.8 1.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m11.9 9.8c-.2 0-.4-.2-.4-.5v-.6c0-.3.2-.5.4-.5.3 0 .5.2.5.5v.7c0 .2-.2.4-.5.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m11.9 17.7c-.2 0-.4-.2-.4-.4v-.7c0-.3.2-.5.4-.5.3 0 .5.2.5.5v.7c0 .2-.2.4-.5.4z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.67d99714eaf58671c3143d38dc68fa38.svg";
export { ForwardRef as ReactComponent };